const DISH_TABLE_SCROLL_VALUES = {
  HEIGHT: 130,
}

export default DISH_TABLE_SCROLL_VALUES
